import { useRef, useCallback } from 'react'

export const useThrottle = <T extends (...args: any[]) => void>(callback: T, delay: number) => {
  const lastCall = useRef<number>(0)

  const throttledFunction = useCallback(
    (...args: Parameters<T>) => {
      const now = new Date().getTime()
      if (now - lastCall.current >= delay) {
        lastCall.current = now
        callback(...args)
      }
    },
    [callback, delay]
  )

  return throttledFunction
}
